import React, { useState } from 'react';
import "./Layout.scss";
import { Layout, Menu, Row, Col, Card, Avatar, Spin, Grid, Button } from 'antd';
import {
  InboxOutlined,
  UserOutlined,
  SwapOutlined,
  ShopOutlined,
  LogoutOutlined,
  MenuOutlined
} from '@ant-design/icons';
import Drawer from "../../components/Drawer";
import { Link, useNavigate } from 'react-router-dom';

const { Sider, Content, Footer } = Layout;
const { SubMenu } = Menu;
const { Meta } = Card;
const { useBreakpoint } = Grid;

export default function LayoutPage(props) {

  const { children } = props;
  const user = JSON.parse(localStorage.getItem('user'));
  const [products] = useState({
    productos: [],
    total: 0,
    count: 0,
    user_id: ''
  });

  let history = useNavigate();
  const [visible, setVisible] = useState(false);
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);

  let role = localStorage.getItem('role');

  const logout = () => {
    history('/');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    localStorage.removeItem('fcm');
  };

  const onItemMenuClick = (route) => {
    history(route);
    setDrawerVisible(false); // Cerrar el drawer al seleccionar un item
  };

  const footerContent = <div className="footer_cart">
    <div>
      <p>Subtotal:</p>
      {
        <p >${products.total}  </p>
      }
    </div>
  </div>;

  if (role === '') {
    return (
      <Row justify='center' align="middle" style={{ height: '100%' }}>
        <Col xs={24} style={{ textAlign: 'center' }}>
          <Spin size="large" tip="Validando" />
        </Col>
      </Row>
    );
  } else {
    return (
      <Layout>
        {/* Botón del menú hamburguesa */}
        <div
          style={{
            position: 'fixed',
            top: 10,
            left: 10,
            zIndex: 1001,
            backgroundColor: '#145F9D',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
          onClick={() => setDrawerVisible(true)}
        >
          <MenuOutlined style={{ fontSize: '18px' }} />
        </div>

        {/* Drawer para el menú lateral */}
        <Drawer
          title="Menú"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          width={screens.lg ? "25%" : '80%'}
        >
          <Menu
            mode="vertical"
            style={{
              backgroundColor: '#145F9D',
              height: '100%',
              borderRight: 0
            }}
            theme="dark"
          >
            <Menu.Item
              key="1"
              icon={<InboxOutlined />}
              onClick={() => onItemMenuClick('/orders/all/1')}
              style={{ color: "#ffffff" }}
            >
              Ordenes
            </Menu.Item>

            <SubMenu
              key="sub2"
              icon={<ShopOutlined />}
              title="Marketplace"
              className='custom-submenu'
            >
              <Menu.Item
                key="2"
                onClick={() => onItemMenuClick('/marketplace')}
                style={{ color: "#ffffff" }}
              >
                Inicio
              </Menu.Item>
              <Menu.Item
                key="22"
                onClick={() => onItemMenuClick('/marketplace/shopping-cart')}
                style={{ color: "#ffffff" }}
              >
                Carrito de compras
              </Menu.Item>
              <Menu.Item
                key="24"
                onClick={() => onItemMenuClick('/marketplace/orders')}
                style={{ color: "#ffffff" }}
              >
                Mis compras
              </Menu.Item>
            </SubMenu>

            <Menu.Item
              key="profile"
              icon={<UserOutlined />}
              style={{
                position: 'absolute',
                bottom: 80,
                width: '100%',
                color: "#ffffff"
              }}
            >
              <a href={user.id !== '' && `/#/@p/${user.id}`} disabled={user.id === '' && true}>
                Perfil
              </a>
            </Menu.Item>

            <Menu.Item
              key="logout"
              icon={<LogoutOutlined />}
              onClick={logout}
              style={{
                position: 'absolute',
                bottom: 40,
                width: '100%',
                color: "#ffffff"
              }}
            >
              Salir
            </Menu.Item>
          </Menu>
        </Drawer>

        <Layout>
          <Content
            className="site-layout-background"
            style={{
              margin: '24px 16px',
              padding: 24
            }}
          >
            {children}
          </Content>
          <Footer style={{ textAlign: 'center' }}>Copyright ©2020 Created by EP&O</Footer>
        </Layout>

        <Drawer
          title={"Mi carrito"}
          footerContent={footerContent}
          visible={visible}
          setVisible={setVisible}
        >
          {
            products.productos.map((prod, index) => (
              <Col key={index}>
                <Card
                  key={index}
                  actions={[
                    <label>Precio(C/U): ${prod.part_cost}</label>,
                    <label>Cant: {prod.qty}</label>
                  ]}
                >
                  <Meta
                    key={index}
                    avatar={<Avatar src={`https://api.epno-app.com${prod.image}`} />}
                    title={prod.name}
                    description={`Part.No: ${prod.part_no}`}
                  />
                </Card>
              </Col>
            ))
          }
        </Drawer>
      </Layout>
    );
  }
}